import { DataTable } from "../../ui/DataTable";
import { useEffect, useState } from "react";
import { DataService } from "../../../services/DataService";
import { _ROUTES } from "../../../utils/_routes_constants";
import {
  _ACTIONS,
  _CRUD,
  _HTTP,
  _MEMBER,
  _SWAL_ICONS,
} from "../../../utils/constants";
import { ColumnBuilder } from "./ColumnBuider";
import { Box, Button } from "@mui/material";
import BasicModal from "../../helpers/BasicModal";
import { object, setLocale, string, number, array } from "yup";
import { useFormik } from "formik";
import { en } from "yup-locales";
import { createToast } from "../../../utils/toast";
import { BasicFormikForm } from "../../form/BasicFormikForm";
import BusinessIcon from "@mui/icons-material/Business";
import {
  currentFiscalYearDateSelect,
  getOptionsAccountParameter,
  getOptionsSelectFiscalYear,
} from "../../../utils/function";

const ListBudget = () => {
  const [rowsData, setRowsData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [refresh, setRefresh] = useState(0);
  const [columns] = useState(ColumnBuilder(setShowModal, setEditData));
  const currentFiscalYear = currentFiscalYearDateSelect();
  const [options, setOptions] = useState({
    fiscalYearDateCopy: [],
    fiscalYear: [],
    increase_account_parameter: [],
  });
  const optionsTypeBudget = [
    { value: "Input only", label: "Input only" },
    { value: "Real only", label: "Real only" },
    { value: "Budget only", label: "Budget only" },
  ];
  const dataService = new DataService();

  // get data if editData is not null
  useEffect(() => {
    if (editData) {
      dataService
        .doRequest(_ACTIONS.GET, _ROUTES.BUDGET + `/${editData.id}`)
        .then((response) => {
          formik.setValues({
            fiscal_year_date_copy: response.data?.fiscal_year_date_copy,
            fiscal_year_version_copy: response.data?.fiscal_year_version_copy,
            fiscal_year_type_copy: response.data?.fiscal_year_type_copy,
            increase: response.data?.increase,
            increase_account_parameter:
              response.data?.increase_account_parameter,
            description: response.data?.description,
            fiscal_year: response.data?.fiscal_year,
            version: response.data?.version,
          });
        });
    }

    const yearsOptions = getOptionsSelectFiscalYear();
    const accountParameterOptions = getOptionsAccountParameter();
    setOptions({
      fiscal_year_date_copy: yearsOptions.map((y) => ({ value: y, label: y })),
      fiscal_year: yearsOptions.map((y) => ({ value: y, label: y })),
      fiscal_year_type_copy: optionsTypeBudget,
      increase_account_parameter: accountParameterOptions,
    });
  }, []);

  // get Data for the form if editData is not null
  useEffect(() => {
    if (editData) {
      formik.setValues({
        fiscal_year: editData?.fiscalYear,
        version: editData?.version,
        fiscal_year_date_copy: editData?.fiscalYearDateCopy,
        fiscal_year_version_copy: editData?.fiscalYearVersionCopy,
        fiscal_year_type_copy: editData?.fiscalYearTypeCopy,
        increase: editData?.increase,
        increase_account_parameter: editData?.increaseAccountParameter ?? [],
        description: editData?.description,
      });
    }
  }, [editData]);

  const v = object({
    fiscal_year: string().required().label("Budget to be created :"),
    version: number().required().min(0).label("Version :"),
    fiscal_year_date_copy: string().label("Fiscal Year to copy :"),
    fiscal_year_version_copy: number().label("Version to copy:"),
    fiscal_year_type_copy: string().label("Type :"),
    increase: number().min(0).label("Apply an increase of :"),
    increase_account_parameter: array().label("Accounts to increase :"),
    description: string().label("Description :"),
  });

  useEffect(() => {
    if (rowsData && rowsData.length === 0) {
      dataService
        .doRequest(_ACTIONS.GET, _ROUTES.BUDGET, {
          "order[created_at]": "desc",
        })
        .then((response) => {
          setRowsData(response[_MEMBER]);
        });
    }
  }, [refresh]);

  setLocale(en);

  const formik = useFormik({
    initialValues: {
      fiscal_year: currentFiscalYear,
      version: "",
      fiscal_year_date_copy: "",
      fiscal_year_version_copy: "",
      fiscal_year_type_copy: "",
      increase: "",
      increase_account_parameter: [],
      description: "",
    },
    onSubmit: (values) => {
      const methode = editData ? _ACTIONS.PATCH : _ACTIONS.POST;
      const url = _ROUTES.NEW_BUDGET + (editData ? `/${editData.id}` : "");
      const budget = {
        fiscal_year_date_copy: values.fiscal_year_date_copy,
        fiscal_year_version_copy: parseInt(values.fiscal_year_version_copy),
        fiscal_year_type_copy: values.fiscal_year_type_copy,
        increase: parseFloat(values.increase),
        increase_account_parameter: values.increase_account_parameter,
        description: values.description,
        fiscal_year: values.fiscal_year,
        version: parseInt(values.version),
        isEdit: editData == null ? false : true,
      };

      dataService
        .doRequest(methode, url, budget, {}, async (res) => {
          const resData = await res.json();
          createToast(
            res.status === _HTTP.created || res.status === _HTTP.ok
              ? _SWAL_ICONS.success
              : _SWAL_ICONS.error,
            resData.data,
          );
          setShowModal(
            !(res.status === _HTTP.created || res.status === _HTTP.ok),
          );
          setEditData(null);
          setRefresh((prev) => {
            return prev + 1;
          });
        })
        .catch(async (res) => {
          const resData = await res.json();
          createToast(_SWAL_ICONS.error, resData.data);
        });
    },
    validationSchema: v,
  });

  formik.special = {
    placeholder: {
      increase_account_parameter: "Select one account or more",
      type: "Select a type",
      activity: "Select an activity",
    },
    helperText: {
      increase_account_parameter:
        "Account to be associated (the sum will be realized)",
    },

    autocomplete: {
      increase_account_parameter: {
        optionLabel: "name",
        optionValue: "id",
        multiple: true,
      },
    },
    multipleSelect: {
      increase_account_parameter: true,
    },
  };

  return (
    <>
      <Box fullWidth>
        <Button
          variant="contained"
          color="success"
          sx={{ float: "right", mb: 2 }}
          onClick={() => {
            setShowModal(true);
            setEditData(null);
          }}
        >
          New Budget
        </Button>
      </Box>
      <DataTable
        rows={rowsData}
        columns={columns}
        fullHeight={true}
        rowHeight={30}
        agGridProps={{
          cellSelection: true,
          copyHeadersToClipboard: false,
          suppressAggFuncInHeader: true,
          getRowClass: (params) => {
            if (!params.data) {
              return "header-group-row";
            }
            return null;
          },
        }}
      />
      <BasicModal
        showModal={showModal}
        setShowModal={setShowModal}
        title={(editData ? _CRUD.update : _CRUD.create) + "  Budget"}
        content={
          <BasicFormikForm
            formik={formik}
            setEditData={setEditData}
            setShowModal={setShowModal}
            validations={v}
            options={options}
          />
        }
        onClose={() => setEditData(null)}
        icon={<BusinessIcon />}
        width={"500"}
      />
    </>
  );
};

export default ListBudget;
